import { defineComponent as _defineComponent } from 'vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { ref, watch, onMounted } from 'vue'
import StudioMemberChip from '@/modules/Studios/components/tabs/StudioMemberChip.vue'
import { fetchStudioStudents } from '@/enitites/studio/api/endpoints'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioStudentsTab',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio | undefined
};



const students = ref<StudioUser[]>([])
const loading = ref(false)
const sortBy = ref<'name'>('name')
const sortDirection = ref<'asc' | 'desc'>('asc')
const pageNumber = ref(0)
const pageSize = ref(100) // Adjust as needed
const keyword = ref('')

const fetchStudents = async () => {
  if (!props.studio?.id) return

  loading.value = true
  try {
    const params: SearchParams = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      keyword: keyword.value,
      sortBy: sortBy.value,
      sortDir: sortDirection.value,
    }

    const fetchedStudents = await fetchStudioStudents(props.studio.id, params)
    students.value = fetchedStudents || []
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studio students',
        studioId: props.studio?.id,
        searchParams: {
          pageNumber: pageNumber.value,
          pageSize: pageSize.value,
          keyword: keyword.value,
          sortBy: sortBy.value,
          sortDir: sortDirection.value,
        },
      })
    })
    students.value = []
  } finally {
    loading.value = false
  }
}

watch([sortBy, sortDirection], () => {
  fetchStudents()
})

watch(
  () => props.studio?.id,
  () => {
    if (props.studio?.id) {
      fetchStudents()
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (props.studio?.id) {
    fetchStudents()
  }
})

return { __sfc: true,props, students, loading, sortBy, sortDirection, pageNumber, pageSize, keyword, fetchStudents, mdiChevronDown, mdiChevronUp, StudioMemberChip }
}

})